import React from "react";
import PropTypes from "prop-types";
import styles from "./TrashButton.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";

export function TrashButton({ onClick, isDisabled = false }) {
  return (
    <div
      className={`${styles.container} ${isDisabled ? styles.disabled : ""}`}
      aria-disabled={isDisabled}
    >
      <FontAwesomeIcon
        icon={faTrashCan}
        className={styles.trashIcon}
        onClick={isDisabled ? undefined : onClick}
      />
    </div>
  );
}
TrashButton.propTypes = {
  /**
   * Function called when clicked
   */
  onClick: PropTypes.func,
  /**
   * Greys out the button and removes click and hover behavior
   */
  isDisabled: PropTypes.bool,
};
export default TrashButton;
